class CronDTO
	constructor: (
		@frequency = null,
		@timeFrom = null,
		@timeTo = null,
		@weekdayFrom = null,
		@weekdayTo = null,
	) ->

	@fromCronExpressionAndDuration: (cronExpression, durationSeconds) ->
		parts = cronExpression.split(' ')

		minute = parseInt(parts[0])
		hour = parseInt(parts[1])
		weekday = parts[4]

		timeFrom = moment().hours(hour).minutes(minute).seconds(0).unix()
		timeTo = moment.unix(timeFrom).add(durationSeconds, 'seconds').unix()

		if weekday != '*'
			weekdayFrom = parseInt(weekday)
			weekdayTo = (weekdayFrom + Math.floor(durationSeconds / (24 * 3600))) % 7
			frequency = 'weekly'
		else
			weekdayFrom = null
			weekdayTo = null
			frequency = 'daily'

		return new CronDTO(frequency, timeFrom, timeTo, weekdayFrom, weekdayTo)
